export const availableColors = <const>[
  "primary",
  "secondary",
  "tertiary",
  "success",
  "warning",
  "error",
  "loading",
  "blue",
  "lightblue",
  "orange",
  "purple",
  "indaco",
  "white",
  "black",
  "grey",
];

export type Color = typeof availableColors[number];
